export const sortingParam = (sorting) => {
  if (!sorting || !sorting.value) {
    return;
  }

  return `${sorting.direction === 'asc' ? '+' : '-'}${sorting.value}`;
};
